import React from "react";
import { allRoutes } from "src/constants/AllRoutes";

const UserProfile = React.lazy(() => import("src/screens/admin/UserProfile"));
const UserProfileSettings = React.lazy(() => import("src/screens/admin/UserProfile/UserProfileSettings"));
const ItineraryManagement = React.lazy(() => import("src/screens/admin/ItineraryManagement"));
const EventManagement = React.lazy(() => import("src/screens/admin/EventManagement"));

const ServiceTypeManagement = React.lazy(() => import("src/screens/admin/ServiceTypeManagement"));
const SupplierManagement = React.lazy(() => import("src/screens/admin/SupplierManagement"));
const ServiceManagement = React.lazy(() => import("src/screens/admin/ServiceManagement"));
const AgencyManagement = React.lazy(() => import("src/screens/admin/AgencyManagement"));
const AgentManagement = React.lazy(() => import("src/screens/admin/AgentManagement"));
const RegionManagement = React.lazy(() => import("src/screens/admin/RegionManagement"));
const TermsConditionsManagement = React.lazy(() => import("src/screens/admin/TermsConditionsManagement"));
const SubAdmin = React.lazy(() => import("src/screens/admin/SubAdmin"));
const Hotels = React.lazy(() => import("src/screens/admin/Hotels"));
const ExclusivelyDashboard = React.lazy(() => import("src/screens/admin/Dashboard"));
const MessageThread = React.lazy(() => import("src/screens/admin/ItineraryManagement/MessageThread"));
const ServiceBookingConfirmationDetails = React.lazy(() => import("src/screens/admin/ItineraryManagement/pages/ServiceBookingConfirmationDetails"));
const SendMessage = React.lazy(() => import("src/screens/admin/ItineraryManagement/pages/SendMessage"));
const SendEmail = React.lazy(() => import("src/screens/admin/ItineraryManagement/pages/SendEmail"));
const Faq = React.lazy(() => import("src/screens/faq"));
const TermsAndConditions = React.lazy(() => import("src/screens/TermsAndConditions"));
const PrivacyPolicy = React.lazy(() => import("src/screens/PrivacyPolicy"));

const privateRoutes = [
  { path: allRoutes.dashboard, Component: ExclusivelyDashboard },
  { path: allRoutes.ProfileMyAccount, Component: UserProfile },
  { path: allRoutes.ProfileSettings, Component: UserProfileSettings },
  { path: allRoutes.itinerary, Component: ItineraryManagement },
  { path: allRoutes.event, Component: EventManagement },
  { path: allRoutes.serviceType, Component: ServiceTypeManagement },
  { path: allRoutes.suppliers, Component: SupplierManagement },
  { path: allRoutes.services, Component: ServiceManagement },
  { path: allRoutes.agency, Component: AgencyManagement },
  { path: allRoutes.agent, Component: AgentManagement },
  { path: allRoutes.region, Component: RegionManagement },
  { path: allRoutes.termsConditions, Component: TermsConditionsManagement },
  { path: allRoutes.subAdmin, Component: SubAdmin },
  { path: allRoutes.hotels, Component: Hotels },
  { path: allRoutes.messageThread, Component: MessageThread },
  { path: allRoutes.itineraryViewServiceBookingConfirmationDetails, Component: ServiceBookingConfirmationDetails },
  { path: allRoutes.itinerarySendMessage, Component: SendMessage },
  { path: allRoutes.itinerarySendEmail, Component: SendEmail },
  { path: allRoutes.faq, Component: Faq },
  { path: allRoutes.privacyPolicy, Component: PrivacyPolicy },
  { path: allRoutes.termsAndConditions, Component: TermsAndConditions }
];

export default privateRoutes;
